export const LowboyAssignmentStatuses = {
    Unfilled: 1,
    Unassigned: 2,
    Planned: 3,
    Dispatched: 4,
    Confirmed: 5,
    Started: 6,
    Completed: 7,
    Submitted: 8,
    Approved: 9,
};
